import { extrasVM } from './Extras.page';
import { ExtrasTabModal } from './components/ExtrasTabModal';
import {
  ArchiveContentModal,
  DeleteContentModal,
  SellAsSubscriptionModal,
  SellAsAnyPurchaseModal,
  SellOnlyInBundleModal,
  UnarchiveContentModal,
} from './components/ContentModals';

export const ExtrasForms = () => {
  const vm = extrasVM.useValue();

  const mode = vm.modalMode;

  const currentContent = vm.contentMap[vm.currentId];
  const tabName =
    currentContent?.type === 'ContentTab' ? currentContent.value.name : '';

  return (
    <>
      {/* Delete confirmation modal */}
      <DeleteContentModal
        isOpen={mode === 'delete'}
        onClose={() => vm.dispatch('CloseModal')}
        onSubmit={() => vm.dispatch('ConfirmDelete')}
      />

      <ArchiveContentModal
        isOpen={mode === 'archive'}
        onClose={() => vm.dispatch('CloseModal')}
        onSubmit={() => vm.dispatch('ConfirmArchive')}
      />

      <UnarchiveContentModal
        isOpen={mode === 'unarchive'}
        onClose={() => vm.dispatch('CloseModal')}
        onSubmit={() => vm.dispatch('ConfirmUnarchive')}
      />

      <SellAsSubscriptionModal
        isOpen={mode === 'sell-as-subscription'}
        onClose={() => vm.dispatch('CloseModal')}
        onSubmit={() => vm.dispatch('ConfirmSellAsSubscription')}
      />

      <SellAsAnyPurchaseModal
        isOpen={mode === 'sell-as-any-purchase'}
        onClose={() => vm.dispatch('CloseModal')}
        onSubmit={() => vm.dispatch('ConfirmSellAsAnyPurchase')}
      />

      <SellOnlyInBundleModal
        isOpen={mode === 'sell-only-in-bundle'}
        onClose={() => vm.dispatch('CloseModal')}
        onSubmit={() => vm.dispatch('ConfirmSellOnlyInBundle')}
      />

      {/* ContentTab modal (simple modal without RHF) */}
      <ExtrasTabModal
        isOpen={
          (mode === 'edit' || mode === 'create') && vm.formType === 'ContentTab'
        }
        onClose={() => vm.dispatch('CloseModal')}
        mode={mode as 'edit' | 'create'}
        onSubmit={(data) => vm.dispatch('SaveTab', data)}
        value={tabName}
      />
    </>
  );
};
